import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { REVENUE_KEYS } from '../../../config/constants/analytics';
import * as selectors from '../selectors';
import AnalyticsHeatmapContainer from './AnalyticsHeatmapContainer';

const GrossRevenueHeatmapChart = ({
  analyticsDataLoading,
  analyticsData,
  selectedTimePeriod,
  isComparisonEnabled,
}) => {
  const currencyCodeList =
    analyticsData && analyticsData.length
      ? analyticsData.map(b => b.currency)
      : [];
  const shouldShowUsd = [...new Set(currencyCodeList)].length > 1;
  const targetRevenueKey = shouldShowUsd
    ? REVENUE_KEYS.REALIZED_REVENUE_USD
    : REVENUE_KEYS.REALIZED_REVENUE;
  const renderChart = (
    <AnalyticsHeatmapContainer
      analyticsData={analyticsData}
      analyticsDataLoading={analyticsDataLoading}
      selectedTimePeriod={selectedTimePeriod}
      targetKey={targetRevenueKey}
      seriesName="Realized Revenue"
      isComparisonEnabled={isComparisonEnabled}
    />
  );
  return <div className="flex flex-col p-4 h-full">{renderChart}</div>;
};
GrossRevenueHeatmapChart.propTypes = {
  analyticsData: PropTypes.array,
  analyticsDataLoading: PropTypes.bool,
  selectedTimePeriod: PropTypes.string,
  isComparisonEnabled: PropTypes.string,
};

const mapStateToProps = createStructuredSelector({
  analyticsDataLoading: selectors.makeSelectAnalyticsDataLoading(),
  analyticsData: selectors.makeSelectAnalyticsData(),
  selectedTimePeriod: selectors.makeSelectTimePeriodSlug(),
  isComparisonEnabled: selectors.makeSelectProperty('selectedComparisonType'),
});

const withConnect = connect(mapStateToProps);
export default compose(withConnect)(GrossRevenueHeatmapChart);
